//imports
import {
    COMPANIES_OVERVIEW_GET_DATA_REQUEST,
    COMPANIES_OVERVIEW_GET_DATA_RESULT,
    GET_TOKEN_ONE_TIME,
    GET_TOKEN_ONE_TIME_RESULT
} from 'Redux/actionTypes';

export const accountgetDataRequest = (data) => ({
    type: COMPANIES_OVERVIEW_GET_DATA_REQUEST,
    payload: data,
});

export const accountgetDataResult = (result) => ({
    type: COMPANIES_OVERVIEW_GET_DATA_RESULT,
    payload: result
});

export const getTokenOneTime = ({username, token, authId}) => ({
    type: GET_TOKEN_ONE_TIME,
    payload: {
        username,
        token,
        authId
    }
});

export const getTokenOneTimeResult = (result) => ({
    type: GET_TOKEN_ONE_TIME_RESULT,
    payload: result
});